/** House bottle sizes. Flip `available` (and add a price later) to launch 20/30 ML. */
export const BOTTLE_SIZES = [
  { ml: 20, label: '20 ML', available: false },
  { ml: 30, label: '30 ML', available: false },
  { ml: 50, label: '50 ML', available: true },
];

export const DEFAULT_SIZE = 50;

export function normalizeSize(ml) {
  const n = Number(ml);
  return BOTTLE_SIZES.some((s) => s.ml === n) ? n : DEFAULT_SIZE;
}

export function isSizeAvailable(ml) {
  return BOTTLE_SIZES.some((s) => s.ml === Number(ml) && s.available);
}

export function sizeLabel(ml) {
  const size = BOTTLE_SIZES.find((s) => s.ml === Number(ml));
  return size?.label || `${normalizeSize(ml)} ML`;
}

export function cartLineKey(productId, ml) {
  return `${productId}::${normalizeSize(ml)}`;
}
